import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
};

// Check if user has a stored preference (safely handle SSR/build environment)
const storedLanguage = typeof window !== 'undefined' ? localStorage.getItem('language') : null;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en'],
    
    detection: {
      // If no stored preference, detect from browser first
      order: storedLanguage 
        ? ['localStorage', 'querystring', 'navigator', 'htmlTag']
        : ['navigator', 'querystring', 'localStorage', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
      // Convert browser languages like 'fr-FR' or 'en-US' to 'fr' or 'en'
      convertDetectedLanguage: (lng: string) => {
        const baseLang = lng.split('-')[0];
        return ['fr', 'en'].includes(baseLang) ? baseLang : 'fr';
      },
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
  });

// Update document lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  const baseLang = lng.split('-')[0];
  document.documentElement.lang = baseLang;
  document.title = i18n.t('meta.title');
  // Store the preference for future visits
  localStorage.setItem('language', baseLang);
});

// Set initial lang attribute
document.documentElement.lang = i18n.language?.split('-')[0] || 'fr';

export default i18n;
